import { FC } from 'react';
import { VideoContentData, VideoFileData } from '../PlayerModels';
import { useRouter } from 'next/router';
import { __t } from '../../../i18n';
import { Ellipsis, Flex, Icon, Text } from '../../../styles';
import UsePlayerProps from '../../../Store/usePlayerProps';
import { IconArrowRight } from '../../../landing/icons';
import {
  CarrierImageMessage,
  CarrierMessageContainer,
  EllipsisWrapper,
  LinkButton,
} from '../styles';

const TitleBar: FC<{ isShort?: boolean }> = ({ isShort }) => {
  const playerGlobalState = UsePlayerProps((state) => state.playerState);
  const { playback_type, message_text, message_image } = playerGlobalState.contentConfigs as VideoFileData;
  const { titles, videoFileType, contentUrl } = playerGlobalState.contentData as VideoContentData;
  const router = useRouter();

  // A short's `contentUrl` is the page it is already on, so there is nothing to link back to.
  // The title bar is the only way out of the shorts player instead, which is why it leaves.
  const handleBack = () => {
    if (isShort) {
      if (window.history.length > 1) router.back();
      else router.push('/');
    } else if (playback_type === 'live_stream') {
      router.push('/live');
    } else {
      router.push(contentUrl);
    }
  };

  return <>
    <LinkButton onClick={handleBack}>
      <Flex>
        <Icon mt={'0.25rem'} ml={'0.25rem'}><IconArrowRight /></Icon>
        <Flex justify={'center'}  direction={'column'}>
          <EllipsisWrapper>
            {titles?.primary}
          </EllipsisWrapper>
          <Ellipsis as="small">{playback_type === 'live_stream' ? __t('player.live') : videoFileType === 'trailer'
            ? __t('player.preview') : titles?.secondary}</Ellipsis>
        </Flex>
      </Flex>
    </LinkButton>
    {message_text && <CarrierMessageContainer>
      {message_image && <CarrierImageMessage src={message_image} />}
      <Text>{message_text}</Text>
    </CarrierMessageContainer>}
  </>;
};

export default TitleBar;
